const parseJson = (value, fallback) => {
    try { return typeof value === 'string' ? JSON.parse(value) : value ?? fallback; }
    catch { return fallback; }
};

const displayValue = value => typeof value === 'string' || typeof value === 'number'
    ? String(value).trim() : '';

export function getProductSpecifications(description, attributes = []) {
    let saved = {};
    const marker = typeof description === 'string' && description.match(/<!-- PRODUCT_NEW_DATA:([A-Za-z0-9+/=\s]+) -->/);
    if (marker) {
        try {
            const json = decodeURIComponent(Array.from(atob(marker[1].trim()), char =>
                '%' + char.charCodeAt(0).toString(16).padStart(2, '0')).join(''));
            saved = parseJson(json, {}) || {};
        } catch { /* Older products may not contain valid metadata. */ }
    }
    const rows = new Map();
    const add = (name, value) => {
        name = displayValue(name);
        value = displayValue(value);
        if (!name || !value) return;
        const key = name.toLocaleLowerCase();
        if (!rows.has(key)) rows.set(key, { name, values: [] });
        if (!rows.get(key).values.includes(value)) rows.get(key).values.push(value);
    };
    const details = parseJson(saved.VariantDetailsJson, {});
    if (details && typeof details === 'object' && !Array.isArray(details)) {
        Object.entries(details).forEach(([name, value]) => add(name, value));
    }
    add('Unit', saved.Unit);
    if (Array.isArray(attributes)) attributes.forEach(item => {
        if (item) add(item.AttributeDisplayName, item.PrimaryKeyDisplayValue);
    });
    const variations = parseJson(saved.ProductVariationsJson, []);
    return {
        requiresVariant: Array.isArray(variations) && variations.length > 0,
        rows: Array.from(rows.values()),
        variations: Array.isArray(variations) ? variations
            .filter(item => item && item.IsActive !== false && item.IsActive !== 'false' && item.IsActive !== 0)
            .map(item => ({
                id: displayValue(item.Id),
                price: item.Price !== null && item.Price !== undefined && item.Price !== '' && Number.isFinite(Number(item.Price)) && Number(item.Price) >= 0 ? Number(item.Price) : null,
                stock: item.Stock !== null && item.Stock !== undefined && item.Stock !== '' && Number.isFinite(Number(item.Stock)) ? Number(item.Stock) : null,
                name: displayValue(item.Name) || 'Option specifications',
                image: displayValue(item.ImageUrl || item.Image || item.Photo || item.ImagePath),
                shortDescription: displayValue(item.ShortDescription),
                description: displayValue(item.FullDescription || item.Description),
                rows: (Array.isArray(item.Attributes) ? item.Attributes : [])
                    .filter(attribute => attribute && displayValue(attribute.Name) && displayValue(attribute.Value))
                    .map(attribute => ({ name: displayValue(attribute.Name), values: [
                        [displayValue(attribute.Value), displayValue(attribute.Unit)].filter(Boolean).join(' ')
                    ] }))
            })).filter(item => item.rows.length || (item.id && item.price !== null)) : []
    };
}
